var _g, _path, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4464_32697)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 16.0001L18.8536 13.8536C19.0491 13.6581 19.0491 13.3421 18.8536 13.1466C18.6581 12.9511 18.3421 12.9511 18.1466 13.1466L16.0001 15.2931L13.8536 13.1466C13.6581 12.9511 13.3421 12.9511 13.1466 13.1466C12.9511 13.3421 12.9511 13.6581 13.1466 13.8536L15.2931 16.0001L13.1466 18.1466C12.9511 18.3421 12.9511 18.6581 13.1466 18.8536C13.2441 18.9511 13.3721 19.0001 13.5001 19.0001C13.6281 19.0001 13.7561 18.9511 13.8536 18.8536L16.0001 16.7071L18.1466 18.8536C18.2441 18.9511 18.3721 19.0001 18.5001 19.0001C18.6281 19.0001 18.7561 18.9511 18.8536 18.8536C19.0491 18.6581 19.0491 18.3421 18.8536 18.1466L16.7071 16.0001Z",
    fill: "#4FCC5D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4464_32697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 7,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 16.0001L18.8536 13.8536C19.0491 13.6581 19.0491 13.3421 18.8536 13.1466C18.6581 12.9511 18.3421 12.9511 18.1466 13.1466L16.0001 15.2931L13.8536 13.1466C13.6581 12.9511 13.3421 12.9511 13.1466 13.1466C12.9511 13.3421 12.9511 13.6581 13.1466 13.8536L15.2931 16.0001L13.1466 18.1466C12.9511 18.3421 12.9511 18.6581 13.1466 18.8536C13.2441 18.9511 13.3721 19.0001 13.5001 19.0001C13.6281 19.0001 13.7561 18.9511 13.8536 18.8536L16.0001 16.7071L18.1466 18.8536C18.2441 18.9511 18.3721 19.0001 18.5001 19.0001C18.6281 19.0001 18.7561 18.9511 18.8536 18.8536C19.0491 18.6581 19.0491 18.3421 18.8536 18.1466L16.7071 16.0001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4464_32697)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 12,
    height: 12,
    fill: "#4FCC5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4464_32697",
    x: 0,
    y: 0,
    width: 35.2,
    height: 35.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.6,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4464_32697"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.6,
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4464_32697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4464_32697",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhatsapp);
export default __webpack_public_path__ + "static/media/closeWhatsapp.938554e4965266d019aa2b7b5e721894.svg";
export { ForwardRef as ReactComponent };